import { render } from "./ModalLoading.vue?vue&type=template&id=24fe75e8&ts=true"
import script from "./ModalLoading.vue?vue&type=script&lang=ts"
export * from "./ModalLoading.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__